import React, { useContext, useEffect, useState } from "react";
import BqnContext from "common/BqnContext";
import { useNavigate } from "react-router-dom";
import ActionsContext from "common/ActionsContext";
import {
  getVersion,
  getSystemName,
  getHardwareId,
  getStartTime,
  getSerialNumber,
  getLicense,
} from "./utils";

const Information = ({ name, value, link }) => {
  const navigate = useNavigate();
  const classNameValue = `font-bold db-counters${
    link ? " hyperlink-text-nocolor" : ""
  }`;
  const handleClick = () => {
    if (!link) {
      return;
    }
    navigate(link);
  };

  return (
    <>
      <div className="col-lg-4 col-md-4 col-sm-4 col-xs-4">
        <div>{name}</div>
      </div>
      <div className="col-lg-8 col-md-8 col-sm-8 col-xs-8">
        <div id="dbSysName" className={classNameValue} onClick={handleClick}>
          {value}
        </div>
      </div>
      <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-b-5"></div>
    </>
  );
};

const DashboardInformation = ({systemdate}) => {
  const actions = useContext(ActionsContext);
  const { bqnId } = useContext(BqnContext);
  const [hardwareId, setHardwareId] = useState({});
  const [systemName, setSystemName] = useState({});
  const [version, setVersion] = useState({});
  const [startTime, setStartTime] = useState("");
  const [serialNumber, setSerialNumber] = useState({});
  const [license, setLicense] = useState({});


  const loadStatics = () => {
    const setters = {
      hardwareId: setHardwareId,
      systemName: setSystemName,
      version: setVersion,
      startTime: setStartTime,
      license: setLicense,
      serialNumber: setSerialNumber,
    };

    const promises = [
      getVersion().then((res) => ({ key: "version", value: res })),
      getSystemName().then((res) => ({ key: "systemName", value: res })),
      getHardwareId().then((res) => ({ key: "hardwareId", value: res })),
      getStartTime(bqnId).then((res) => ({ key: "startTime", value: res })),
      getSerialNumber().then((res) => ({ key: "serialNumber", value: res })),
      getLicense(bqnId).then((res) => ({ key: "license", value: res })),
    ];

    promises.forEach((promise) => {
      promise.then(({ key, value }) => {
        if (setters[key]) {
          setters[key](value);
        }
      }).catch((error) => {
        console.error(`Error fetching dashboard data:`, error);
      });
    });
  };

  useEffect(() => {
    loadStatics();
    return actions.recv("do-load", loadStatics);
  }, [bqnId]);

  const isReadyLicense = license?.[bqnId] && license?.[bqnId].length > 0;

  return (
    <div className="card">
      <div className="body dashboard-information">
        <div className="row">
          <Information name="System Name" value={systemName?.[bqnId]} />
          <Information
            name="BQN Release"
            value={version?.[bqnId]}
            link="/viewSoftware"
          />
          <Information name="Hardware ID" value={hardwareId?.[bqnId]} />
          <Information name="Start Time" value={startTime} />
          <Information name="Serial Number" value={serialNumber?.[bqnId]} />
          <Information name="System Time" value={systemdate} />
          <Information
            name="License Limit"
            value={isReadyLicense ? license?.[bqnId]?.[0] : "n/a"}
            link="/viewLicense"
          />
          <Information
            name="License Expiration"
            value={isReadyLicense ? license?.[bqnId]?.[1] : "n/a"}
            link="/viewLicense"
          />
        </div>
      </div>
    </div>
  );
};

export default DashboardInformation;
